import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Aggiungi token a ogni richiesta
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => localStorage.removeItem('token')
};

export const appointmentService = {
  getAvailableSlots: (date, type) => api.get(`/appointments?date=${date}&type=${type}`),
  getMyBookings: () => api.get('/appointments/my-bookings'),
  book: (data) => api.post('/appointments/book', data),
  cancel: (id) => api.delete(`/appointments/cancel/${id}`)
};

export const adminService = {
  getDashboard: () => api.get('/admin/dashboard'),
  updateSettings: (data) => api.post('/admin/settings', data),
  exportData: () => api.get('/admin/export')
};

export default api;
